export default __webpack_public_path__ + "static/media/Form-Etica-y-Ciudadana.615c3f3c.png";